import React from 'react';
import Header from '../Header';
import ContactUsFooter from '../ContactUs/ContactUsFooter';
import './Orthodontics.css';

const Orthodontics = () => {
    const pricing = [
        { type: "Metal Brackets", price: "$50,000 UP" },
        { type: "Ceramic Brackets", price: "$80,000 UP" },
        { type: "Self-Ligatinf Metal Brackets", price: "$1003,000 UP" },
        { type: "Self-Ligatinf Ceramic Brackets", price: "$120,000 UP" },
        { type: "Clear Aligners", price: "$250,000 - $300,000" },
        { type: "Functional Appliance", price: "$20,000 - $25,000" },
        { type: "Hawley's Retainer (U/L)", price: "$12,000" },
        { type: "Essix Retainers", price: "$14,000" },
        { type: "Fixed Retainers", price: "$10,000 UP" },
        { type: "Temporary Anchorage Device", price: "$,8,000" },
        { type: "Bracket Recementation", price: "$1000 - $1,500" },
        { type: "Bracket Removal", price: "$10,000 UP" },
        { type: "Downpayment", price: "30% - 50%" },
    ];

    return (
        <>
        <Header />
        <div className="onthrodontics-container">
            <div className="onthrodontics-content">
                <h1>ORTHODONTICS</h1>
                <p>
                Orthodontics is a dental specialty focused on aligning teeth and correcting bite issues.
                Common treatments include braces and clear aligners. 2  Orthodontic treatment can improve not 
                only the appearance of teeth but also their function, reducing the risk of dental problems like 
                cavities and gum disease. The duration of treatment varies depending on the complexity of the case. 
                </p>
                <h2>Pricing</h2>
                <table className="onthrodontics-table">
                        <thead>
                            <tr>
                                <th>Type of Surgery</th>
                                <th>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pricing.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.type}</td>
                                    <td>{item.price}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <ContactUsFooter />
        </>
    );
};


export default Orthodontics;